import { create } from "zustand"

export const boxplotHorizontalStore = create((set) => ({
  // INFO: 차트에 실제로 쓰이는 상태 (가로형)
  color: "pink",
  boxplotY: ["전체"], // 가로형이므로 카테고리가 y축에 위치
  boxplotSeries: null,
  scatterSeries: null,

  setChart: (id, data, customColors) => {
    const [min, q1, med, q3, max] = data.boxplot
    const color = customColors[data.apt_size] || "pink"

    // INFO: 박스 데이터 (항상 1건만 들어감 - 가로형 변환)
    const boxplotSeries = {
      type: "custom",
      data: [[min, q1, med, q3, max]],
      renderItem: (params, api) => {
        // ! y좌표는 카테고리 index 기준 (가로형은 카테고리가 Y축)
        const y = api.coord([med, 0])[1]

        // ! x좌표는 값 → 화면 좌표 (가로형은 값이 X축)
        const xMin = api.coord([min, 0])[0]
        const xMax = api.coord([max, 0])[0]
        const xQ1 = api.coord([q1, 0])[0]
        const xQ3 = api.coord([q3, 0])[0]
        const xMed = api.coord([med, 0])[0]

        const lineWidth = 150
        const boxWidth = 250

        const boxLeft = Math.min(xQ1, xQ3)
        const boxWidthSize = Math.abs(xQ1 - xQ3)

        return {
          type: "group",
          children: [
            // INFO: 가로 라인 (최소 ~ 최대 연결)
            {
              type: "line",
              shape: {
                x1: xMin,
                y1: y,
                x2: xMax,
                y2: y
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: box (Q1 ~ Q3) - 가로형 사각형
            {
              type: "rect",
              shape: {
                x: boxLeft,
                y: y - boxWidth / 2,
                width: boxWidthSize,
                height: boxWidth
              },
              style: {
                fill: "#fdfdfd",
                stroke: color,
                lineWidth: 2
              }
            },

            // INFO: 세로라인 최좌측 (Min)
            {
              type: "line",
              shape: {
                x1: xMin,
                y1: y - lineWidth / 2,
                x2: xMin,
                y2: y + lineWidth / 2
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: 세로라인 중앙 (Median)
            {
              type: "line",
              shape: {
                x1: xMed,
                y1: y - boxWidth / 2,
                x2: xMed,
                y2: y + boxWidth / 2
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: 세로라인 최우측 (Max)
            {
              type: "line",
              shape: {
                x1: xMax,
                y1: y - lineWidth / 2,
                x2: xMax,
                y2: y + lineWidth / 2
              },
              style: { stroke: color, lineWidth: 2 }
            }
          ]
        }
      }
    }

    // 2. 이상치 데이터 (가로형은 y축 인덱스를 0으로 고정, x값이 사용량)
    const scatterData = data.outliers.map((o) => [
      o.usage, // x축 값 (사용량)
      0, // y축 위치 (첫 번째 칸)
      o.unit_id, // 툴팁용
      id // 색상 매칭용
    ])

    const scatterSeries = {
      name: "Outlier",
      type: "scatter",
      data: scatterData,
      symbolSize: 10,
      itemStyle: { color: (p) => customColors[p.data[3]] || "pink" }
    }

    set({
      boxplotY: [id],
      boxplotSeries,
      scatterSeries,
      color
    })
  },

  reset: () => {
    set({
      color: "pink",
      boxplotY: ["전체"],
      boxplotSeries: null,
      scatterSeries: null
    })
  }
}))
